import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "checkout-popover-header" }
const _hoisted_3 = { class: "checkout-popover-content" }

import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import { QuestionMarkCircleIcon } from '@heroicons/vue/24/outline';
import { ref } from 'vue';

interface TooltipProps {
  header: string;
  content: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    header: null,
    content: null
  },
  setup(__props: any) {



const isOpen = ref(false);

const open = () => {
  isOpen.value = true;
};

const close = () => {
  isOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), { class: "popover-container" }, {
    default: _withCtx(() => [
      _createVNode(_unref(PopoverButton), {
        class: "checkout-popover-button",
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (open())),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (close())),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (open()))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(QuestionMarkCircleIcon), { class: "checkout-popover-icon" })
        ]),
        _: 1
      }),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(PopoverPanel), {
              class: "checkout-popover-panel",
              static: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.header), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(__props.content), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})